export const AUTHENTICATE_LOGIN_ACTIONS = {
  AUTHENTICATE_LOGIN_REQUEST: "AUTHENTICATE_LOGIN_REQUEST",
  AUTHENTICATE_LOGIN_RESPONSE: "AUTHENTICATE_LOGIN_RESPONSE",
  AUTHENTICATE_LOGIN_ERROR: "AUTHENTICATE_LOGIN_ERROR",
};

export const AUTHENTICATE_REFRESH_TOKEN_ACTIONS = {
  AUTHENTICATE_REFRESH_TOKEN_REQUEST: "AUTHENTICATE_REFRESH_TOKEN_REQUEST",
  AUTHENTICATE_REFRESH_TOKEN_RESPONSE: "AUTHENTICATE_REFRESH_TOKEN_RESPONSE",
  AUTHENTICATE_REFRESH_TOKEN_ERROR: "AUTHENTICATE_REFRESH_TOKEN_ERROR",
};

export const AUTHENTICATE_REGISTER_ACTIONS = {
  AUTHENTICATE_REGISTER_REQUEST: "AUTHENTICATE_REGISTER_REQUEST",
  AUTHENTICATE_REGISTER_RESPONSE: "AUTHENTICATE_REGISTER_RESPONSE",
  AUTHENTICATE_REGISTER_ERROR: "AUTHENTICATE_REGISTER_ERROR",
};

export const AUTHENTICATE_LOGOUT_ACTIONS = {
  AUTHENTICATE_LOGOUT_REQUEST: "AUTHENTICATE_LOGOUT_REQUEST",
  AUTHENTICATE_LOGOUT_RESPONSE: "AUTHENTICATE_LOGOUT_RESPONSE",
  AUTHENTICATE_LOGOUT_ERROR: "AUTHENTICATE_LOGOUT_ERROR",
};
export const AUTHENTICATE_DEVICE_LOGOUT_ACTIONS = {
  AUTHENTICATE_DEVICE_LOGOUT_REQUEST: "AUTHENTICATE_DEVICE_LOGOUT_REQUEST",
  AUTHENTICATE_DEVICE_LOGOUT_RESPONSE: "AUTHENTICATE_DEVICE_LOGOUT_RESPONSE",
  AUTHENTICATE_DEVICE_LOGOUT_ERROR: "AUTHENTICATE_DEVICE_LOGOUT_ERROR",
};


export const AUTHENTICATE_FORGOT_ACTIONS = {
  AUTHENTICATE_FORGOT_REQUEST: "AUTHENTICATE_FORGOT_REQUEST",
  AUTHENTICATE_FORGOT_RESPONSE: "AUTHENTICATE_FORGOT_RESPONSE",
  AUTHENTICATE_FORGOT_ERROR: "AUTHENTICATE_FORGOT_ERROR",
};
export const AUTHENTICATE_RESET_ACTIONS = {
  AUTHENTICATE_RESET_REQUEST: "AUTHENTICATE_RESET_REQUEST",
  AUTHENTICATE_RESET_RESPONSE: "AUTHENTICATE_RESET_RESPONSE",
  AUTHENTICATE_RESET_ERROR: "AUTHENTICATE_RESET_ERROR",
};
export const AUTHENTICATE_CHANGE_ACTIONS = {
  AUTHENTICATE_CHANGE_REQUEST: "AUTHENTICATE_CHANGE_REQUEST",
  AUTHENTICATE_CHANGE_RESPONSE: "AUTHENTICATE_CHANGE_RESPONSE",
  AUTHENTICATE_CHANGE_ERROR: "AUTHENTICATE_CHANGE_ERROR",
};
export const AUTHENTICATE_GETEMAIL_OTP_ACTIONS = {
  AUTHENTICATE_GETEMAIL_OTP_REQUEST: "AUTHENTICATE_GETEMAIL_OTP_REQUEST",
  AUTHENTICATE_GETEMAIL_OTP_RESPONSE: "AUTHENTICATE_GETEMAIL_OTP_RESPONSE",
  AUTHENTICATE_GETEMAIL_OTP_ERROR: "AUTHENTICATE_GETEMAIL_OTP_ERROR",
};
export const AUTHENTICATE_ACTIVATE_ACTIONS = {
  AUTHENTICATE_ACTIVATE_REQUEST: "AUTHENTICATE_ACTIVATE_REQUEST",
  AUTHENTICATE_ACTIVATE_RESPONSE: "AUTHENTICATE_ACTIVATE_RESPONSE",
  AUTHENTICATE_ACTIVATE_ERROR: "AUTHENTICATE_ACTIVATE_ERROR",
};
export const AUTHENTICATE_RESENDEMAIL_ACTIONS = {
  AUTHENTICATE_RESENDEMAIL_REQUEST: "AUTHENTICATE_RESENDEMAIL_REQUEST",
  AUTHENTICATE_RESENDEMAIL_RESPONSE: "AUTHENTICATE_RESENDEMAIL_RESPONSE",
  AUTHENTICATE_RESENDEMAIL_ERROR: "AUTHENTICATE_RESENDEMAIL_ERROR",
};
export const AUTHENTICATE_NOTIFICATION_ACTIONS = {
  AUTHENTICATE_NOTIFICATION_REQUEST: "AUTHENTICATE_NOTIFICATION_REQUEST",
  AUTHENTICATE_NOTIFICATION_RESPONSE: "AUTHENTICATE_NOTIFICATION_RESPONSE",
  AUTHENTICATE_NOTIFICATION_ERROR: "AUTHENTICATE_NOTIFICATION_ERROR",
};
export const REMOVE_NOTIFICATION_ACTIONS = {
  REMOVE_NOTIFICATION_REQUEST: "REMOVE_NOTIFICATION_REQUEST",
  REMOVE_NOTIFICATION_RESPONSE: "REMOVE_NOTIFICATION_RESPONSE",
  REMOVE_NOTIFICATION_ERROR: "REMOVE_NOTIFICATION_ERROR",
};
export const IS_USER_EXITS_ACTIONS = {
  IS_USER_EXITS_REQUEST: "IS_USER_EXITS_REQUEST",
  IS_USER_EXITS_RESPONSE: "IS_USER_EXITS_RESPONSE",
  IS_USER_EXITS_ERROR: "REMOVE_NOTIFICATION_ERROR",
};
export const IS_USER_NAME_OR_EMAIL_AVAILABLE_ACTIONS = {
  IS_USER_NAME_OR_EMAIL_AVAILABLE_REQUEST: "IS_USER_NAME_OR_EMAIL_AVAILABLE_REQUEST",
  IS_USER_NAME_OR_EMAIL_AVAILABLE_RESPONSE: "IS_USER_NAME_OR_EMAIL_AVAILABLE_RESPONSE",
  IS_USER_NAME_OR_EMAIL_AVAILABLE_ERROR: "IS_USER_NAME_OR_EMAIL_AVAILABLE_ERROR",
};
export const CHANGE_ACCOUNT_PASSWORD_ACTIONS = {
  CHANGE_ACCOUNT_PASSWORD_REQUEST: "CHANGE_ACCOUNT_PASSWORD_REQUEST",
  CHANGE_ACCOUNT_PASSWORD_RESPONSE: "CHANGE_ACCOUNT_PASSWORD_RESPONSE",
  CHANGE_ACCOUNT_PASSWORD_ERROR: "CHANGE_ACCOUNT_PASSWORD_ERROR",
};
export const REQUEST_EMAIL_CHANGE_ACTIONS = {
  REQUEST_EMAIL_CHANGE_REQUEST: "REQUEST_EMAIL_CHANGE_REQUEST",
  REQUEST_EMAIL_CHANGE_RESPONSE: "REQUEST_EMAIL_CHANGE_RESPONSE",
  REQUEST_EMAIL_CHANGE_ERROR: "REQUEST_EMAIL_CHANGE_ERROR",
};
export const AUTHENTICATE_OAUTH_LOGIN_ACTIONS = {
  AUTHENTICATE_OAUTH_LOGIN_REQUEST: "AUTHENTICATE_OAUTH_LOGIN_REQUEST",
  AUTHENTICATE_OAUTH_LOGIN_RESPONSE: "AUTHENTICATE_OAUTH_LOGIN_RESPONSE",
  AUTHENTICATE_OAUTH_LOGIN_ERROR: "AUTHENTICATE_OAUTH_LOGIN_ERROR",
};